import { render } from "./TraineesSlug.vue?vue&type=template&id=76b26510"
import script from "./TraineesSlug.vue?vue&type=script&lang=js"
export * from "./TraineesSlug.vue?vue&type=script&lang=js"

import "./TraineesSlug.vue?vue&type=style&index=0&id=76b26510&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__